import React, { useEffect,useState } from 'react';
import {Steps, Alert, Skeleton, Button, Form, Input, Space, Avatar, Table, Divider, message, Result} from "antd";
import {useMutation, useQuery} from "react-query";
import { useParams, useNavigate } from "react-router-dom";
import {GetRelease, PublishRelease, UpdateRelease} from "../../../../../api/release";
import { GetApp } from "../../../../../api/apps";  
import Moment from "moment";
import Config from "../../../../../config";
import {AndroidOutlined} from "@ant-design/icons";

export const PublishReleaseController = (props) => {
    const [ step, setStep ] = useState(0);
    const [ finished, setFinished] = useState(false)
    const [appData, setAppData] = useState(null);  // Добавляем состояние для данных о приложении
    const params = useParams();
    const nav = useNavigate();
    const { developer_id, app_id, release_id } = params;

 
    useEffect(() => {
        GetApp(params.developer_id, params.app_id)
            .then(data => {
                setAppData(data.app);
            })
            .catch(error => {
                console.error("Failed to get app data", error);
            });
    }, [params.developer_id, params.app_id]);


    const ReleaseRequest = useQuery(
        ['release', developer_id, app_id, release_id],
        () => GetRelease(developer_id, app_id, release_id)
    );

    const UpdateReleaseMutations = useMutation(
        (data) => UpdateRelease(developer_id, app_id, release_id, data),
        {
            onSuccess: (data) => {
                setStep(1)
            },
            onError: (e) => {
                console.error(`[UpdateReleaseMutations] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    );

    const PublishReleaseMutation = useMutation(
        () => PublishRelease(developer_id, app_id, release_id),
        {
            onSuccess: (data) => {
                setFinished(true)
            },
            onError: (e) => {
                console.error(`[PublishReleaseMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    if (ReleaseRequest.isLoading) {
        return (
            <div className={`dev__layout release--layout`}>
                <Skeleton />
            </div>
        )
    }

    const release = ReleaseRequest?.data?.release || {};
    const app = ReleaseRequest?.data?.app || {};
    const appErrors = ReleaseRequest?.data?.app_errors || [];

    function bytesToSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }

    if (finished) {
        return (
            <Result
                status="success"
                title="Ваш выпуск успешно отправлен на модерацию"
                subTitle="Скоро его проверят модераторы, вы получите уведомление о результатах проверки"
                extra={[
                    <Button type="primary" key="console" onClick={() => {nav(`/console/${developer_id}/app/${app_id}/release`)}}>
                        Закрыть
                    </Button>,
                ]}
            />
        )
    }


    return (
        <div className={`dev__layout release--layout`}>
            <Steps current={step}>
                <Steps.Step title={`Проверка выпуска`}/>
                <Steps.Step title={`Публикация`}/>
            </Steps>
            {step === 0 && (
                <>
                    <Form
                        layout={`vertical`}
                        initialValues={{
                            release_name: release?.release_name || "",
                            release_description: release?.release_description || "",
                        }}
                        onFinish={(data) => UpdateReleaseMutations.mutate(data)}
                    >
                        <div className={`release--alerts__block`}>
                            <Alert
                                type={`info`}
                                message={`Проверьте настройки вашего выпуска перед отправкой на модерацию`}
                            />
                        </div>
                        <div className="release__block">
                            <ReleaseTable
                                app_type={appData ? appData.type : null} 
                                release={release}
                            />
                        </div>
                        <Divider>Примечание к выпуску</Divider>
                        <ReleaseForm />
                        <div className={`release--footer`}>
                            <Button onClick={() => {nav(`/console/${developer_id}/app/${app_id}/release`)}} type={`link`}>Отменить</Button>
                            <Button type={`primary`} htmlType={`submit`}>Продолжить</Button>
                        </div>
                    </Form>
                </>
            )}
            {(step === 1) && (
                <>
                    <div className="alerts--block">
                        <Alert
                            type={`info`}
                            message={`Проверьте информацию о приложении, которая будет отображаться пользователям`}
                        />
                        {ReleaseRequest?.data?.is_valid_app === false && (
                            <Alert
                                message={`Заполнена не вся информация о приложении`}
                                description={<>{appErrors.map(i => <p>{i}</p>)}</>}
                                type={`warning`}
                                action={
                                    <Space>
                                        <Button size="small" type="primary" onClick={() => {
                                            window.open(`/console/${developer_id}/app/${app_id}/store`);
                                        }}>
                                            Открыть настройки
                                        </Button>
                                    </Space>
                                }
                            />
                        )}
                        <div className="application">
                            <div className="application__header">
                                <div className={`logo`}>
                                    <AppAvatar {...app}/>
                                </div>
                                <div className={`application__info`}>
                                    <div className="title">{app.title}</div>
                                    <div className="short_description">{app.short_description}</div>
                                </div>
                            </div>
                            <div className={`application_description`}>{app.description}</div>
                            <div className={`application__options`}>
                                <div className={`app_option`}>
                                    <span className={`label`}>Тип приложения</span>
                                    <span className={`value`}>{app.type === 'application' ? `Приложение` : `Игра`}</span>
                                </div>
                                <div className={`app_option`}>
                                    <span className={`label`}>Версия приложения</span>
                                    <span className={`value`}>{`${release.version_code} (${release.version_name})`}</span>
                                </div>
                                <div className={`app_option`}>
                                    <span className={`label`}>Размер приложения</span>
                                    <span className={`value`}>{bytesToSize(release.size)}</span>
                                </div>
                                <div className={`app_option`}>
                                    <span className={`label`}>Категория</span>
                                    <span className={`value`}>{app.category_name}</span>
                                </div>
                                <div className={`app_option`}>
                                    <span className={`label`}>Наличие рекламы</span>
                                    <span className={`value`}>{app.ads ? `Да` : `нет`}</span>
                                </div>
                                <div className={`app_option`}>
                                    <span className={`label`}>Возрастные ограничения</span>
                                    <span className={`value`}>{app.age_restrictions}</span>
                                </div>
                                <div className={`app_option`}>
                                    <span className={`label`}>Политика конфиденциальности</span>
                                    <span className={`value`}>{app.privacy_url}</span>
                                </div>
                                <div className={`app_option`}>
                                    <span className={`label`}>Email поддержки</span>
                                    <span className={`value`}>{app?.contacts?.email || ""}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`release--footer`}>
                        <Button onClick={() => {nav(`/console/${developer_id}/app/${app_id}/release`)}} type={`link`}>Отменить</Button>
                        <Button
                            type={`primary`}
                            htmlType={`submit`}
                            disabled={ReleaseRequest?.data?.is_valid_app === false}
                            loading={PublishReleaseMutation.isLoading}
                            onClick={() => PublishReleaseMutation.mutate()}
                        >Отправить на проверку</Button>
                    </div>
                </>
            )}

        </div>
    );
}

const ReleaseForm = () => {
    return (
        <div className={`release__form`}>
            <Form.Item
                label={`Название выпуска`}
                name={`release_name`}
                rules={[{required: true, message: `Укажите название выпуска`}]}
            >
                <Input maxLength={120} showCount/>
            </Form.Item>
            <Form.Item
                label={`Примечание к выпуску`}
                name={`release_description`}
                extra={`Укажите, что обновили`}
                rules={[{required: true, message: `Укажите примечание к выпуску`}]}
            >
                <Input.TextArea maxLength={5000}/>
            </Form.Item>
        </div>
    );
}

const ReleaseTable = ({ app_type, release }) => {
   
   
   
   /*
    const columns = [
        {
            title: '',
            key: 'icon',
            render: r => {
                const dateIndex = Moment(r.createdAt).utc().format("YYYY-MM-DD")
                return (<Avatar size={40} shape={`square`}
                                src={`${Config.MEDIA.APK_IMAGE}/${dateIndex}/${r.release_prefix}/${r.store_icon}`}/>)
            }
        },
        {
            title: "Тип файла",
            key: "file_type",
            render: r => `APK`
        },
        {
            title: "Версия",
            key: "version",
            render: r => {
                return (`${r.version_code} (${r.version_name})`);
            }
        },
        {
            title: 'Версия API',
            key: 'api',
            align: 'center',
            render: r => {
                return `${r.sdk_min}+`
            }
        },
        {
            title: 'Текущая SDK',
            key: 'sdk',
            align: 'center',
            render: r => {
                return `${r.sdk_target}`
            }
        },
        {
            title: 'Количество разрешений',
            key: 'permissions',
            align: 'center',
            render: r => {
                return `${r.permissions.length}`
            }
        }
    ];
*/

let columns = [
    {
        title: '',
        key: 'icon',
        render: r => {
            const dateIndex = Moment(r.createdAt).utc().format("YYYY-MM-DD")
            return (<Avatar size={40} shape={`square`}
                            src={`${Config.MEDIA.APK_IMAGE}/${dateIndex}/${r.release_prefix}/${r.store_icon}`}/>)
        }
    }];





    if (app_type && app_type === 'linux') {
        columns.push(
            // Специфические поля для Linux
            {
                title: "Название пакета",
                key: "package_name",
                render: r => r.package_name
            },
            {
                title: "Тип файла",
                key: "file_type",
                render: r => `RPM`
            },
            {
                title: "Версия",
                key: "version",
                render: r => {
                    return (`${r.version_code} (${r.version_name})`);
                }
            },
            {
                title: "ОС",
                key: "os",
                render: r => r.os
            },
            {
                title: "Архитектура",
                key: "architecture",
                render: r => r.architecture
            } 
        );
    } else {
        columns.push(
            {
                title: "Название пакета",
                key: "package_name",
                render: r => r.package_name
            },{
                title: "Тип файла",
                key: "file_type",
                render: r => `APK`
            },
            {
                title: "Версия",
                key: "version",
                render: r => {
                    return (`${r.version_code} (${r.version_name})`);
                }
            },
            {
                title: 'Версия API',
                key: 'api',
                align: 'center',
                render: r => {
                    return `${r.sdk_min}+`
                }
            },
            {
                title: 'Текущая SDK',
                key: 'sdk',
                align: 'center',
                render: r => {
                    return `${r.sdk_target}`
                }
            },
            {
                title: 'Количество разрешений',
                key: 'permissions',
                align: 'center',
                render: r => {
                    return `${r.permissions.length}`
                }
            } 
        );
    }

 


    const data = [release];
    return (
        <div className="table__info">
            <Table
                columns={columns}
                dataSource={data}
                locale={{'emptyText': 'У вас пока нет релизов на публикацию'}}
                rowKey={(item) => item.id}
                pagination={{
                    hideOnSinglePage: true,
                }}
            />
        </div>
    )
}


const AppAvatar = (props) => {
    let avatarProps = {
        shape: 'square',
        icon: <AndroidOutlined />,
        size: 128,
    };

    if (props.media) {
        const icon = props.media.filter(i => i.type === 'icon');
        if (icon.length > 0) {
            avatarProps.src = `${Config.MEDIA.IMAGES}/${icon[0].hash}/medium`;
        }
    }

    return  <Avatar {...avatarProps}/>;
}

export default PublishReleaseController;